// PaginationBarDataTables.js
import React from 'react'

function PaginationBarDataTables({ pagination, goToPage, getPaginationButtons }) {
  if (!pagination.total) return null

  let btnIdx = 0
  return (
    <div className="d-flex justify-content-between align-items-center my-2 flex-wrap">
      {/* Showing X to Y of Z entries */}
      <div style={{ fontSize: 12, marginBottom: 8 }}>
        Showing {pagination.from} to {pagination.to} of {pagination.total} entries
      </div>
      {/* Pagination */}
      <div className="dataTables_paginate paging_simple_numbers" id="dataTable_paginate">
        <a
          className={
            'paginate_button previous' + (pagination.current_page === 1 ? ' disabled' : '')
          }
          aria-controls="dataTable"
          data-dt-idx={btnIdx++}
          tabIndex="0"
          id="dataTable_previous"
          style={{
            pointerEvents: pagination.current_page === 1 ? 'none' : 'auto',
            color: pagination.current_page === 1 ? '#aaa' : '#333',
            marginRight: 3,
            padding: '4px 10px',
            cursor: 'pointer',
          }}
          onClick={() => goToPage(pagination.current_page - 1)}
        >
          Previous
        </a>
        <span>
          {getPaginationButtons().map((pg, i) =>
            pg === '...' ? (
              <span className="ellipsis" key={i} style={{ padding: '0 8px' }}>
                …
              </span>
            ) : (
              <a
                key={i}
                className={'paginate_button' + (pg === pagination.current_page ? ' current' : '')}
                aria-controls="dataTable"
                data-dt-idx={btnIdx++}
                tabIndex="0"
                style={{
                  minWidth: 28,
                  textAlign: 'center',
                  background: pg === pagination.current_page ? '#333' : '',
                  marginLeft: 1,
                  marginRight: 1,
                  boxShadow: pg === pagination.current_page ? '0 0 2px #aaa' : '',
                  color: pg === pagination.current_page ? '#fff' : '#333',
                  cursor: pg === pagination.current_page ? 'default' : 'pointer',
                  pointerEvents: pg === pagination.current_page ? 'none' : 'auto',
                  padding: '4px 10px',
                }}
                onClick={() => goToPage(pg)}
              >
                {pg}
              </a>
            ),
          )}
        </span>
        <a
          className={
            'paginate_button next' +
            (pagination.current_page === pagination.last_page ? ' disabled' : '')
          }
          aria-controls="dataTable"
          data-dt-idx={btnIdx++}
          tabIndex="0"
          id="dataTable_next"
          style={{
            pointerEvents: pagination.current_page === pagination.last_page ? 'none' : 'auto',
            color: pagination.current_page === pagination.last_page ? '#aaa' : '#333',
            marginLeft: 3,
            padding: '4px 10px',
            cursor: 'pointer',
          }}
          onClick={() => goToPage(pagination.current_page + 1)}
        >
          Next
        </a>
      </div>
    </div>
  )
}

export default PaginationBarDataTables
